export enum ProductType {
    PHYSICAL = 'ITEM',
    DIGITAL = 'VOUCHER',
    PHISICAL_AND_DIGITAL= 'WALLET'
}